import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_guest-retreat-finder/artifacts/ymwgc3ta_Logo%20Quattro%20Accommodations.png";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-violet px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle at 20% 30%, #00C9A7 0, transparent 40%), radial-gradient(circle at 80% 70%, #1DE9B6 0, transparent 40%)" }} />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO} alt="Quattro" className="h-12 w-auto object-contain mx-auto bg-white/95 rounded-xl p-2" />
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white rounded-3xl p-8 shadow-2xl space-y-5">
          <div>
            <h1 className="font-serif text-2xl text-brand-plum">Area riservata</h1>
            <p className="text-sm text-brand-plum/50 mt-1">Accedi al pannello di gestione Quattro</p>
          </div>
          <div>
            <Label className="text-brand-plum">Email</Label>
            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" className="mt-1.5" placeholder="admin@quattro.house" />
          </div>
          <div>
            <Label className="text-brand-plum">Password</Label>
            <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" className="mt-1.5" placeholder="••••••••" />
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="w-full rounded-xl bg-brand-plum hover:bg-brand-violet text-white h-11">
            {loading ? "Accesso..." : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}
